
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16 px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="font-serif text-2xl mb-6">SYG Yachts</h3>
            <p className="text-gray-400 leading-relaxed">
              Boutique superyacht brokerage and advisory firm delivering discreet expertise worldwide.
            </p>
          </div>

          <div>
            <h4 className="text-sm tracking-widest mb-6">SERVICES</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">Yacht Sales & Acquisitions</li>
              <li className="hover:text-white transition-colors cursor-pointer">Yacht Charter</li>
              <li className="hover:text-white transition-colors cursor-pointer">New Build Management</li>
              <li className="hover:text-white transition-colors cursor-pointer">Refit Management</li>
              <li className="hover:text-white transition-colors cursor-pointer">Crew Placement</li>
              <li className="hover:text-white transition-colors cursor-pointer">Yacht Financing</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm tracking-widest mb-6">CONTACT</h4>
            <ul className="space-y-3 text-gray-400">
              <li>Email: info@sygyachts.com</li>
              <li>Phone: +1.954.529.6377</li>
              <li>Fort Lauderdale, Florida</li>
              <li>Viareggio, Italy</li>
              <li>Available 24/7 for our clients</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2025 SYG Yachts. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
